import { useState, useEffect, useCallback, useMemo, useRef } from "react";
import axiosInstance from "../../api/axiosInstance"
const PAGE_SIZE = 10;
const TOAST_DURATION = 4000;

const api = {
  list: (params = {}) => {
    const p = {};
    if (params.search)   p.q         = params.search;
    if (params.createdBy) p.created_by_id = params.createdBy;
    if (params.isActive !== "" && params.isActive !== undefined)
                         p.is_active = params.isActive;
    return axiosInstance.get("/api/superadmin/buyer-item-masters/", { params: p });
  },
  get:    (id)       => axiosInstance.get(`/api/superadmin/buyer-item-masters/${id}/`),
  create: (body)     => axiosInstance.post("/api/superadmin/buyer-item-masters/", body),
  patch:  (id, body) => axiosInstance.patch(`/api/superadmin/buyer-item-masters/${id}/`, body),
  delete: (id)       => axiosInstance.delete(`/api/superadmin/buyer-item-masters/${id}/`),
};

const SearchIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);
const CloseIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const ChevronLeftIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const ChevronRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
const EyeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);
const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);
const PlusIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
const UserIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);
const ClockIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>
);
const BoxIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
  </svg>
);
const TagIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
    <line x1="7" y1="7" x2="7.01" y2="7" />
  </svg>
);
const DollarIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);
const LoaderIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    style={{ animation: "bim-spin 0.8s linear infinite" }}>
    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
  </svg>
);
const AlertTriangleIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

let _toastSetter = null;
const toast = {
  _push: (item) => {
    const id = Date.now() + Math.random();
    _toastSetter?.((p) => [...p, { id, ...item }]);
    return id;
  },
  success: (title, msg) => toast._push({ type: "success", title, msg }),
  error:   (title, msg) => toast._push({ type: "error",   title, msg }),
  info:    (title, msg) => toast._push({ type: "info",    title, msg }),
  loading: (title)      => toast._push({ type: "loading", title, persistent: true }),
  dismiss: (id)         => _toastSetter?.((p) => p.filter((t) => t.id !== id)),
};
const TOAST_META = {
  success: { bar: "#16a34a", icon: "✓" },
  error:   { bar: "#dc2626", icon: "✕" },
  info:    { bar: "#1d4ed8", icon: "i" },
  loading: { bar: "#94a3b8", icon: null },
};
const ToastItem = ({ t, onDismiss }) => {
  const meta = TOAST_META[t.type];
  const [progress, setProgress] = useState(100);
  const [exiting, setExiting]   = useState(false);
  const rafRef   = useRef(null);
  const startTs  = useRef(Date.now());
  const dismiss  = useCallback(() => {
    setExiting(true);
    setTimeout(() => onDismiss(t.id), 280);
  }, [t.id, onDismiss]);
  useEffect(() => {
    if (t.persistent) return;
    const tick = () => {
      const pct = Math.max(0, 100 - ((Date.now() - startTs.current) / TOAST_DURATION) * 100);
      setProgress(pct);
      if (pct > 0) rafRef.current = requestAnimationFrame(tick);
      else dismiss();
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [t.persistent, dismiss]);
  return (
    <div style={{ position: "relative", overflow: "hidden", background: "#fff", borderRadius: 10, borderLeft: `4px solid ${meta.bar}`, boxShadow: "0 4px 20px rgba(0,0,0,0.10), 0 0 0 1px rgba(0,0,0,0.06)", minWidth: 300, maxWidth: 360, animation: exiting ? "bim-out 0.28s ease forwards" : "bim-in 0.28s cubic-bezier(0.34,1.56,0.64,1) forwards" }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "13px 14px 14px" }}>
        <div style={{ flexShrink: 0, width: 24, height: 24, borderRadius: "50%", background: `${meta.bar}18`, display: "flex", alignItems: "center", justifyContent: "center", marginTop: 1 }}>
          {t.type === "loading"
            ? <svg width="13" height="13" viewBox="0 0 13 13" fill="none" style={{ animation: "bim-spin 0.85s linear infinite" }}><circle cx="6.5" cy="6.5" r="5" stroke={meta.bar} strokeWidth="2" strokeDasharray="8 20" strokeLinecap="round" /></svg>
            : <span style={{ fontSize: 11, fontWeight: 800, color: meta.bar, lineHeight: 1 }}>{meta.icon}</span>}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ margin: 0, fontSize: 13.5, fontWeight: 650, color: "#0f172a", lineHeight: 1.35 }}>{t.title}</p>
          {t.msg && <p style={{ margin: "3px 0 0", fontSize: 12.5, color: "#64748b", lineHeight: 1.5 }}>{t.msg}</p>}
        </div>
        <button onClick={dismiss} style={{ background: "none", border: "none", cursor: "pointer", color: "#cbd5e1", padding: "2px", flexShrink: 0, display: "flex", borderRadius: 4 }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#94a3b8")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#cbd5e1")}>
          <CloseIcon />
        </button>
      </div>
      {!t.persistent && (
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 3, background: "#f1f5f9" }}>
          <div style={{ height: "100%", width: `${progress}%`, background: meta.bar, transition: "width 0.1s linear", borderRadius: "0 2px 0 0" }} />
        </div>
      )}
    </div>
  );
};
const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);
  _toastSetter = setToasts;
  const dismiss = useCallback((id) => setToasts((p) => p.filter((t) => t.id !== id)), []);
  if (!toasts.length) return null;
  return (
    <div style={{ position: "fixed", bottom: 24, right: 24, zIndex: 9999, display: "flex", flexDirection: "column", gap: 10, alignItems: "flex-end" }}>
      {toasts.map((t) => <ToastItem key={t.id} t={t} onDismiss={dismiss} />)}
    </div>
  );
};

const Pagination = ({ currentPage, totalPages, totalCount, onPageChange }) => {
  if (totalPages <= 1) return null;
  const startItem = (currentPage - 1) * PAGE_SIZE + 1;
  const endItem   = Math.min(currentPage * PAGE_SIZE, totalCount);
  const getPages  = () => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages = [1];
    if (currentPage > 3) pages.push("...");
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) pages.push(i);
    if (currentPage < totalPages - 2) pages.push("...");
    pages.push(totalPages);
    return pages;
  };
  const btnBase = { display: "inline-flex", alignItems: "center", justifyContent: "center", minWidth: 34, height: 34, padding: "0 6px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: "pointer", background: "#fff", color: "#374151", transition: "all 0.15s", lineHeight: 1 };
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 20px", borderTop: "1px solid #f1f5f9", background: "#f8fafc", flexWrap: "wrap", gap: 10 }}>
      <span style={{ fontSize: 13, color: "#64748b" }}>
        Showing <strong style={{ color: "#374151" }}>{startItem}–{endItem}</strong> of <strong style={{ color: "#374151" }}>{totalCount}</strong> results
      </span>
      <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
        <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}
          style={{ ...btnBase, opacity: currentPage === 1 ? 0.4 : 1, cursor: currentPage === 1 ? "not-allowed" : "pointer" }}>
          <ChevronLeftIcon />
        </button>
        {getPages().map((p, i) =>
          p === "..."
            ? <span key={`e${i}`} style={{ padding: "0 4px", color: "#94a3b8", fontSize: 13, lineHeight: "34px" }}>…</span>
            : <button key={p} onClick={() => onPageChange(p)} className={p === currentPage ? "" : "bim-page-btn"}
                style={{ ...btnBase, ...(p === currentPage ? { background: "#3b82f6", color: "#fff", border: "1px solid #3b82f6", fontWeight: 600 } : {}) }}>
                {p}
              </button>
        )}
        <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}
          style={{ ...btnBase, opacity: currentPage === totalPages ? 0.4 : 1, cursor: currentPage === totalPages ? "not-allowed" : "pointer" }}>
          <ChevronRightIcon />
        </button>
      </div>
    </div>
  );
};

const SkeletonRow = () => (
  <tr style={{ borderBottom: "1px solid #f1f5f9" }}>
    {[40, 160, 130, 80, 80, 100, 100, 90].map((w, i) => (
      <td key={i} style={{ padding: "14px 16px" }}>
        <div style={{ height: 13, width: w, maxWidth: "100%", borderRadius: 6, background: "linear-gradient(90deg,#f1f5f9 25%,#e2e8f0 50%,#f1f5f9 75%)", backgroundSize: "200% 100%", animation: "bim-shimmer 1.4s infinite" }} />
      </td>
    ))}
  </tr>
);
const TableSkeleton = () => <>{Array.from({ length: 6 }).map((_, i) => <SkeletonRow key={i} />)}</>;

const ActiveBadge = ({ value }) => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600, background: value ? "#dcfce7" : "#fee2e2", color: value ? "#16a34a" : "#dc2626" }}>
    <span style={{ width: 6, height: 6, borderRadius: "50%", background: value ? "#22c55e" : "#f43f5e", display: "inline-block" }} />
    {value ? "Active" : "Inactive"}
  </span>
);

const StatsBar = ({ items, loading }) => {
  const total    = items.length;
  const active   = items.filter((i) => i.is_active).length;
  const inactive = total - active;
  const Card = ({ label, count, color, bg, border }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 18px", borderRadius: 10, background: bg, border: `1px solid ${border}`, minWidth: 110 }}>
      <div style={{ width: 8, height: 8, borderRadius: "50%", background: color, flexShrink: 0 }} />
      <div>
        <div style={{ fontSize: 18, fontWeight: 700, color: "#0f172a", lineHeight: 1.1 }}>
          {loading
            ? <div style={{ width: 28, height: 16, borderRadius: 4, background: "#e2e8f0", animation: "bim-shimmer 1.4s infinite" }} />
            : count}
        </div>
        <div style={{ fontSize: 11.5, color: "#64748b", fontWeight: 550, marginTop: 2, letterSpacing: "0.02em" }}>{label}</div>
      </div>
    </div>
  );
  return (
    <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
      <Card label="Total Items" count={total}    color="#6366f1" bg="#f5f3ff" border="#e0e7ff" />
      <Card label="Active"      count={active}   color="#16a34a" bg="#f0fdf4" border="#bbf7d0" />
      <Card label="Inactive"    count={inactive} color="#dc2626" bg="#fef2f2" border="#fecaca" />
    </div>
  );
};

const InfoRow = ({ icon, label, value, mono }) => (
  <div style={{ display: "flex", alignItems: "flex-start", gap: 8, padding: "7px 0", borderBottom: "1px solid #f8fafc" }}>
    <span style={{ color: "#94a3b8", display: "flex", flexShrink: 0, marginTop: 1 }}>{icon}</span>
    <span style={{ fontSize: 12.5, color: "#94a3b8", fontWeight: 550, minWidth: 130, flexShrink: 0 }}>{label}</span>
    <span style={{ fontSize: 13, color: mono ? "#1e40af" : "#1e293b", fontWeight: mono ? 700 : 500, fontFamily: mono ? "monospace" : "inherit", flex: 1, wordBreak: "break-word" }}>
      {value ?? <span style={{ color: "#cbd5e1" }}>—</span>}
    </span>
  </div>
);

const FormField = ({ label, required, error, children, hint }) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
    <label style={{ fontSize: 12.5, fontWeight: 650, color: "#374151", display: "flex", alignItems: "center", gap: 4 }}>
      {label}
      {required && <span style={{ color: "#dc2626", fontSize: 13 }}>*</span>}
    </label>
    {children}
    {hint && !error && <span style={{ fontSize: 11.5, color: "#94a3b8" }}>{hint}</span>}
    {error && <span style={{ fontSize: 11.5, color: "#dc2626", fontWeight: 550 }}>{error}</span>}
  </div>
);

const inputStyle = (hasError = false) => ({
  padding: "9px 12px",
  border: `1px solid ${hasError ? "#fca5a5" : "#e2e8f0"}`,
  borderRadius: 8,
  fontSize: 13.5,
  background: hasError ? "#fff5f5" : "#f8fafc",
  color: "#1e293b",
  outline: "none",
  fontFamily: "inherit",
  width: "100%",
  boxSizing: "border-box",
  transition: "border-color 0.15s, background 0.15s",
});

const DeleteConfirmModal = ({ item, onConfirm, onCancel, deleting }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onCancel(); };
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKey);
    };
  }, [onCancel]);

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.60)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1100, padding: 20 }}
      onClick={onCancel}
    >
      <div
        style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 420, boxShadow: "0 24px 64px rgba(0,0,0,0.20)", animation: "bim-fade-up 0.2s ease", padding: "28px 28px 24px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", gap: 14, alignItems: "flex-start", marginBottom: 20 }}>
          <div style={{ width: 44, height: 44, borderRadius: 12, background: "#fee2e2", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, color: "#dc2626" }}>
            <AlertTriangleIcon />
          </div>
          <div>
            <h3 style={{ margin: "0 0 6px", fontSize: 16, fontWeight: 700, color: "#0f172a" }}>Delete Item Master</h3>
            <p style={{ margin: 0, fontSize: 13.5, color: "#64748b", lineHeight: 1.55 }}>
              Are you sure you want to delete <strong style={{ color: "#0f172a" }}>{item?.item_name}</strong>? This action cannot be undone.
            </p>
          </div>
        </div>
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          <button onClick={onCancel} disabled={deleting}
            style={{ padding: "9px 20px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13.5, fontWeight: 600, cursor: "pointer", background: "#fff", color: "#374151", transition: "background 0.15s" }}
            onMouseEnter={(e) => { if (!deleting) e.currentTarget.style.background = "#f8fafc"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "#fff"; }}>
            Cancel
          </button>
          <button onClick={onConfirm} disabled={deleting}
            style={{ padding: "9px 20px", border: "none", borderRadius: 8, fontSize: 13.5, fontWeight: 600, cursor: deleting ? "not-allowed" : "pointer", background: deleting ? "#fca5a5" : "#dc2626", color: "#fff", display: "flex", alignItems: "center", gap: 7, transition: "background 0.15s", opacity: deleting ? 0.8 : 1 }}>
            {deleting ? <><LoaderIcon /> Deleting…</> : <><TrashIcon /> Delete</>}
          </button>
        </div>
      </div>
    </div>
  );
};

const ViewDetailModal = ({ itemId, onClose, onEdit }) => {
  const [detail,  setDetail]  = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get(itemId);
        if (!cancelled) setDetail(data?.data ?? data);
      } catch {
        if (!cancelled) toast.error("Failed to Load", "Could not fetch item details. Please try again.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [itemId]);

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20 }}
      onClick={onClose}
    >
      <div
        style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 600, boxShadow: "0 24px 64px rgba(0,0,0,0.20)", animation: "bim-fade-up 0.2s ease", display: "flex", flexDirection: "column", maxHeight: "90vh" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: "1px solid #f1f5f9", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div>
              <h2 style={{ margin: 0, fontSize: 15.5, fontWeight: 700, color: "#0f172a" }}>Item Master Details</h2>
            </div>
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            {detail && (
              <button
                onClick={() => { onClose(); onEdit(detail); }}
                style={{ display: "flex", alignItems: "center", gap: 6, padding: "7px 14px", background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 7, fontSize: 13, fontWeight: 600, cursor: "pointer", color: "#2563eb", transition: "background 0.15s" }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#dbeafe")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "#eff6ff")}
              >
                <EditIcon /> Edit
              </button>
            )}
            <button onClick={onClose}
              style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", display: "flex", padding: 6, borderRadius: 6 }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#64748b")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#94a3b8")}>
              <CloseIcon />
            </button>
          </div>
        </div>

        <div style={{ padding: "20px 24px 24px", overflowY: "auto", flex: 1 }}>
          {loading ? (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 14, padding: "40px 20px" }}>
              <LoaderIcon />
              <p style={{ margin: 0, fontSize: 14, color: "#94a3b8" }}>Loading item details…</p>
            </div>
          ) : !detail ? (
            <div style={{ textAlign: "center", padding: "40px 20px" }}>
              <p style={{ fontSize: 14, color: "#dc2626" }}>Failed to load details. Please close and try again.</p>
            </div>
          ) : (
            <>
              <div style={{ background: "linear-gradient(135deg, #fafafa 0%, #f9fafc 100%)", borderRadius: 10, padding: "16px 20px", marginBottom: 18, display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12, flexWrap: "wrap" }}>
                <div>
                  <p style={{ margin: "0 0 4px", fontSize: 11, fontWeight: 700, color: "#555960", letterSpacing: "0.08em", textTransform: "uppercase" }}>Item Name</p>
                  <p style={{ margin: 0, fontSize: 17, fontWeight: 800, color: "#0f1316" }}>{detail.item_name}</p>
                </div>
                <ActiveBadge value={detail.is_active} />
              </div>

              <InfoRow icon={<TagIcon />}    label="Particulars"        value={detail.particulars} />
              <InfoRow icon={<BoxIcon />}    label="Default Quantity"   value={`${parseFloat(detail.default_qty).toLocaleString()} ${detail.unit || ""}`.trim()} />
              <InfoRow icon={<DollarIcon />} label="Default Unit Price" value={parseFloat(detail.default_unit_price) > 0 ? `₹ ${parseFloat(detail.default_unit_price).toLocaleString("en-IN", { minimumFractionDigits: 2 })}` : "—"} />
              <InfoRow icon={<UserIcon />}   label="Created By"         value={`${detail.created_by_name} (${detail.created_by_email})`} />
              <InfoRow icon={<ClockIcon />}  label="Created At"         value={detail.created_at} />
              <InfoRow icon={<ClockIcon />}  label="Updated At"         value={detail.updated_at} />

              {detail.specifications && (
                <div style={{ marginTop: 16 }}>
                  <p style={{ margin: "0 0 8px", fontSize: 12.5, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em" }}>Specifications</p>
                  <div
                    style={{ padding: "12px 16px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 13, color: "#374151", lineHeight: 1.7 }}
                    dangerouslySetInnerHTML={{ __html: detail.specifications }}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const EMPTY_FORM = {
  item_name:          "",
  particulars:        "",
  default_qty:        "",
  unit:               "",
  default_unit_price: "",
  specifications:     "",
  is_active:          true,
};

const FormModal = ({ mode, initialData, onClose, onSuccess }) => {
  const isEdit = mode === "edit";
  const [form,   setForm]   = useState(isEdit ? { ...EMPTY_FORM, ...initialData } : EMPTY_FORM);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  const setField = (key, value) => {
    setForm((p) => ({ ...p, [key]: value }));
    setErrors((p) => ({ ...p, [key]: undefined }));
  };

  const validate = () => {
    const e = {};
    if (!form.item_name.trim())   e.item_name   = "Item name is required.";
    if (!form.particulars.trim()) e.particulars  = "Particulars is required.";
    if (form.default_qty === "" || isNaN(Number(form.default_qty)))
                                  e.default_qty  = "Enter a valid quantity.";
    if (form.default_unit_price !== "" && isNaN(Number(form.default_unit_price)))
                                  e.default_unit_price = "Enter a valid price.";
    return e;
  };

  const applyApiErrors = (apiErrors) => {
    const mapped = {};
    Object.entries(apiErrors).forEach(([key, msgs]) => {
      mapped[key] = Array.isArray(msgs) ? msgs[0] : msgs;
    });
    setErrors(mapped);
  };

  const handleSubmit = async () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      toast.error("Validation Failed", "Please fix the highlighted fields.");
      return;
    }

    setSaving(true);
    const loadingId = toast.loading(isEdit ? "Updating item…" : "Creating item…");

    const payload = {
      item_name:          form.item_name.trim(),
      particulars:        form.particulars.trim(),
      default_qty:        parseFloat(form.default_qty).toFixed(2),
      unit:               form.unit.trim(),
      default_unit_price: form.default_unit_price !== "" ? parseFloat(form.default_unit_price).toFixed(2) : "0.00",
      specifications:     form.specifications,
      is_active:          form.is_active,
    };

    try {
      const { data } = isEdit
        ? await api.patch(initialData.id, payload)
        : await api.create(payload);

      toast.dismiss(loadingId);
      toast.success(
        isEdit ? "Item Updated" : "Item Created",
        isEdit
          ? `"${form.item_name}" has been updated successfully.`
          : `"${form.item_name}" has been created successfully.`
      );
      onSuccess(data?.data ?? data);

    } catch (err) {
      toast.dismiss(loadingId);
      const status = err?.response?.status;
      const body   = err?.response?.data;

      if (status === 400) {
        if (typeof body === "object" && !Array.isArray(body) && !body?.detail) {
          applyApiErrors(body);
          toast.error("Validation Failed", "Please fix the highlighted fields.");
        } else {
          toast.error("Request Failed", body?.detail || "Invalid request. Please check your inputs.");
        }
      } else if (status === 403) {
        toast.error("Access Denied", "You don't have permission to perform this action.");
      } else if (status === 404) {
        toast.error("Not Found", "The item no longer exists.");
      } else if (!err.response) {
        toast.error("Network Error", "Unable to reach the server. Check your connection.");
      } else {
        toast.error("Server Error", `Unexpected error (HTTP ${status}). Please try again.`);
      }
      setSaving(false);
    }
  };

  const iBase = (key) => ({ ...inputStyle(!!errors[key]), transition: "border-color 0.15s" });

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20 }}
      onClick={onClose}
    >
      <div
        style={{ background: "#fff", borderRadius: 14, width: "100%", maxWidth: 580, boxShadow: "0 24px 64px rgba(0,0,0,0.20)", animation: "bim-fade-up 0.2s ease", display: "flex", flexDirection: "column", maxHeight: "92vh" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 24px", borderBottom: "1px solid #f1f5f9", flexShrink: 0 }}>
          <div>
            <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: "#0f172a" }}>
              {isEdit ? "Edit Item Master" : "Create Item Master"}
            </h2>
            <p style={{ margin: "2px 0 0", fontSize: 12, color: "#94a3b8" }}>
              {isEdit ? `Editing: ${initialData?.item_name}` : "Fill in the details to create a new item master."}
            </p>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#94a3b8", display: "flex", padding: 6, borderRadius: 6 }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#64748b")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#94a3b8")}>
            <CloseIcon />
          </button>
        </div>

        <div style={{ padding: "22px 24px", overflowY: "auto", flex: 1, display: "flex", flexDirection: "column", gap: 16 }}>
          <FormField label="Item Name" required error={errors.item_name}>
            <input
              style={{ ...iBase("item_name"), ...(isEdit ? { background: "#f1f5f9", color: "#94a3b8", cursor: "not-allowed" } : {}) }}
              value={form.item_name}
              onChange={(e) => !isEdit && setField("item_name", e.target.value)}
              placeholder="e.g. HP Laptop"
              readOnly={isEdit}
              onFocus={(e) => { if (!isEdit) e.target.style.borderColor = "#3b82f6"; }}
              onBlur={(e)  => { e.target.style.borderColor = errors.item_name ? "#fca5a5" : "#e2e8f0"; }}
            />
            {isEdit && <span style={{ fontSize: 11.5, color: "#94a3b8" }}>Item name cannot be changed after creation.</span>}
          </FormField>

          <FormField label="Particulars" required error={errors.particulars}>
            <input
              style={iBase("particulars")}
              value={form.particulars}
              onChange={(e) => setField("particulars", e.target.value)}
              placeholder="Short description of the item"
              onFocus={(e) => (e.target.style.borderColor = "#3b82f6")}
              onBlur={(e)  => (e.target.style.borderColor = errors.particulars ? "#fca5a5" : "#e2e8f0")}
            />
          </FormField>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
            <FormField label="Default Quantity" required error={errors.default_qty}>
              <input
                type="number" min="0" step="0.01"
                style={iBase("default_qty")}
                value={form.default_qty}
                onChange={(e) => setField("default_qty", e.target.value)}
                placeholder="e.g. 5"
                onFocus={(e) => (e.target.style.borderColor = "#3b82f6")}
                onBlur={(e)  => (e.target.style.borderColor = errors.default_qty ? "#fca5a5" : "#e2e8f0")}
              />
            </FormField>
            <FormField label="Unit" error={errors.unit} hint="e.g. Pieces, pcs, kg">
              <input
                style={iBase("unit")}
                value={form.unit}
                onChange={(e) => setField("unit", e.target.value)}
                placeholder="e.g. Pieces"
                onFocus={(e) => (e.target.style.borderColor = "#3b82f6")}
                onBlur={(e)  => (e.target.style.borderColor = "#e2e8f0")}
              />
            </FormField>
          </div>

          <FormField label="Default Unit Price" error={errors.default_unit_price} hint="Leave blank or 0 if not applicable.">
            <input
              type="number" min="0" step="0.01"
              style={iBase("default_unit_price")}
              value={form.default_unit_price}
              onChange={(e) => setField("default_unit_price", e.target.value)}
              placeholder="e.g. 12000.00"
              onFocus={(e) => (e.target.style.borderColor = "#3b82f6")}
              onBlur={(e)  => (e.target.style.borderColor = errors.default_unit_price ? "#fca5a5" : "#e2e8f0")}
            />
          </FormField>

          <FormField label="Specifications" error={errors.specifications} hint="Supports HTML markup for rich formatting.">
            <textarea
              rows={5}
              style={{ ...iBase("specifications"), resize: "vertical", lineHeight: 1.55 }}
              value={form.specifications}
              onChange={(e) => setField("specifications", e.target.value)}
              placeholder="Enter item specifications (plain text or HTML)…"
              onFocus={(e) => (e.target.style.borderColor = "#3b82f6")}
              onBlur={(e)  => (e.target.style.borderColor = "#e2e8f0")}
            />
          </FormField>

          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", background: "#f8fafc", borderRadius: 8, border: "1px solid #e2e8f0" }}>
            <div>
              <p style={{ margin: 0, fontSize: 13.5, fontWeight: 650, color: "#374151" }}>Active Status</p>
              <p style={{ margin: "2px 0 0", fontSize: 12, color: "#94a3b8" }}>Inactive items won't appear in RFQ item selection.</p>
            </div>
            <button
              onClick={() => setField("is_active", !form.is_active)}
              style={{ width: 44, height: 24, borderRadius: 12, border: "none", cursor: "pointer", background: form.is_active ? "#22c55e" : "#e2e8f0", padding: 2, transition: "background 0.2s", position: "relative", flexShrink: 0 }}>
              <span style={{ display: "block", width: 20, height: 20, borderRadius: "50%", background: "#fff", boxShadow: "0 1px 3px rgba(0,0,0,0.2)", transition: "transform 0.2s", transform: form.is_active ? "translateX(20px)" : "translateX(0)" }} />
            </button>
          </div>
        </div>

        <div style={{ padding: "14px 24px 20px", borderTop: "1px solid #f1f5f9", display: "flex", gap: 10, justifyContent: "flex-end", flexShrink: 0 }}>
          <button onClick={onClose} disabled={saving}
            style={{ padding: "9px 22px", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 13.5, fontWeight: 600, cursor: saving ? "not-allowed" : "pointer", background: "#fff", color: "#374151" }}
            onMouseEnter={(e) => { if (!saving) e.currentTarget.style.background = "#f8fafc"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "#fff"; }}>
            Cancel
          </button>
          <button onClick={handleSubmit} disabled={saving}
            style={{ padding: "9px 22px", border: "none", borderRadius: 8, fontSize: 13.5, fontWeight: 600, cursor: saving ? "not-allowed" : "pointer", background: saving ? "#93c5fd" : "#3b82f6", color: "#fff", display: "flex", alignItems: "center", gap: 7, transition: "background 0.15s" }}
            onMouseEnter={(e) => { if (!saving) e.currentTarget.style.background = "#2563eb"; }}
            onMouseLeave={(e) => { if (!saving) e.currentTarget.style.background = "#3b82f6"; }}>
            {saving ? <><LoaderIcon /> {isEdit ? "Updating…" : "Creating…"}</> : isEdit ? "Update Item" : "Create Item"}
          </button>
        </div>
      </div>
    </div>
  );
};

const BuyerItemMaster = () => {
  const [allItems,     setAllItems]     = useState([]);
  const [loading,      setLoading]      = useState(true);
  const [currentPage,  setCurrentPage]  = useState(1);
  const [search,       setSearch]       = useState("");
  const [filterActive, setFilterActive] = useState("");

  const [viewId,     setViewId]     = useState(null);
  const [editItem,   setEditItem]   = useState(null);
  const [deleteItem, setDeleteItem] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const [deleting,   setDeleting]   = useState(false);

  const fetchItems = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.list({ search, isActive: filterActive });
      setAllItems(data?.results ?? data ?? []);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 403) {
        toast.error("Access Denied", "You don't have permission to view item masters.");
      } else if (!err.response) {
        toast.error("Network Error", "Unable to reach the server.");
      } else {
        toast.error("Failed to Load", `Unable to fetch item masters (HTTP ${status}).`);
      }
    } finally {
      setLoading(false);
    }
  }, [search, filterActive]);

  useEffect(() => { setCurrentPage(1); }, [search, filterActive]);
  useEffect(() => { const t = setTimeout(fetchItems, 350); return () => clearTimeout(t); }, [fetchItems]);

  const totalCount = allItems.length;
  const totalPages = Math.ceil(totalCount / PAGE_SIZE);
  const pagedItems = useMemo(
    () => allItems.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE),
    [allItems, currentPage]
  );

  const hasFilters   = search || filterActive !== "";
  const clearFilters = () => { setSearch(""); setFilterActive(""); };

  const handleCreateSuccess = (newItem) => {
    setShowCreate(false);
    setAllItems((prev) => [newItem, ...prev]);
    fetchItems();
  };

  const handleEditSuccess = (updatedItem) => {
    setEditItem(null);
    setAllItems((prev) =>
      prev.map((it) => (it.id === updatedItem.id ? { ...it, ...updatedItem } : it))
    );
    fetchItems();
  };

  const handleDelete = async () => {
    if (!deleteItem) return;
    setDeleting(true);
    const loadingId = toast.loading("Deleting item…");
    try {
      await api.delete(deleteItem.id);
      toast.dismiss(loadingId);
      toast.success("Item Deleted", `"${deleteItem.item_name}" has been removed successfully.`);
      setAllItems((prev) => prev.filter((it) => it.id !== deleteItem.id));
      setDeleteItem(null);
      const newTotal = totalCount - 1;
      const newPages = Math.ceil(newTotal / PAGE_SIZE);
      if (currentPage > newPages && newPages > 0) setCurrentPage(newPages);
    } catch (err) {
      toast.dismiss(loadingId);
      const status = err?.response?.status;
      if (status === 403) {
        toast.error("Access Denied", "You don't have permission to delete this item.");
      } else if (status === 404) {
        toast.error("Not Found", "This item no longer exists.");
        setAllItems((prev) => prev.filter((it) => it.id !== deleteItem.id));
        setDeleteItem(null);
      } else if (!err.response) {
        toast.error("Network Error", "Unable to reach the server. Check your connection.");
      } else {
        toast.error("Unexpected Error", `Something went wrong (HTTP ${status}).`);
      }
    } finally {
      setDeleting(false);
    }
  };

  const filterInputBase = {
    padding: "8px 12px",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    fontSize: 13.5,
    background: "#f8fafc",
    color: "#1e293b",
    outline: "none",
    fontFamily: "inherit",
  };

  const COLS = ["Sr No.", "Item Name", "Particulars", "Qty", "Unit", "Status", "Created By", "Actions"];

  return (
    <div style={{ fontFamily: "'Inter', -apple-system, sans-serif", padding: 24, background: "#f8fafc", minHeight: "100vh", color: "#1e293b" }}>
      <style>{`
        @keyframes bim-shimmer  { 0%   { background-position: 200% 0; }   100% { background-position: -200% 0; } }
        @keyframes bim-fade-up  { from { opacity: 0; transform: translateY(8px); }  to { opacity: 1; transform: translateY(0); } }
        @keyframes bim-in       { from { opacity: 0; transform: translateX(24px) scale(0.97); } to { opacity: 1; transform: translateX(0) scale(1); } }
        @keyframes bim-out      { from { opacity: 1; transform: translateX(0) scale(1); } to { opacity: 0; transform: translateX(28px) scale(0.95); } }
        @keyframes bim-spin     { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        .bim-row:hover          { background: #f8fafc !important; cursor: pointer; }
        .bim-action-btn:hover   { opacity: 0.85; }
        .bim-page-btn:hover     { background: #f1f5f9 !important; border-color: #cbd5e1 !important; }
        * { box-sizing: border-box; }
      `}</style>

      <ToastContainer />

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24, flexWrap: "wrap", gap: 12 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: "#0f172a" }}>Buyer Item Masters</h1>
          <p style={{ margin: "4px 0 0", fontSize: 13, color: "#64748b" }}>Manage the master catalogue of purchasable items used across RFQs</p>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={fetchItems}
            style={{ display: "flex", alignItems: "center", gap: 6, padding: "9px 18px", background: "#fff", color: "#374151", border: "1px solid #e2e8f0", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", transition: "background 0.15s", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f5f9")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}>
            {loading ? <LoaderIcon /> : (
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" />
                <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
              </svg>
            )}
            Refresh
          </button>
          <button onClick={() => setShowCreate(true)}
            style={{ display: "flex", alignItems: "center", gap: 6, padding: "9px 18px", background: "#3b82f6", color: "#fff", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", transition: "background 0.15s", boxShadow: "0 1px 3px rgba(0,0,0,0.12)" }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#2563eb")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#3b82f6")}>
            <PlusIcon /> Add Item
          </button>
        </div>
      </div>

      <StatsBar items={allItems} loading={loading} />

      <div style={{ background: "#fff", borderRadius: 12, padding: "14px 18px", border: "1px solid #e2e8f0", marginBottom: 16, display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.04)" }}>
        <div style={{ position: "relative", flex: "1 1 200px" }}>
          <span style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", display: "flex", pointerEvents: "none" }}>
            <SearchIcon />
          </span>
          <input
            style={{ ...filterInputBase, width: "100%", paddingLeft: 34 }}
            placeholder="Search item masters…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onFocus={(e) => (e.target.style.borderColor = "#3b82f6")}
            onBlur={(e)  => (e.target.style.borderColor = "#e2e8f0")}
          />
        </div>
        <select
          style={{ ...filterInputBase, cursor: "pointer", flex: "0 1 140px" }}
          value={filterActive}
          onChange={(e) => setFilterActive(e.target.value)}>
          <option value="">All Status</option>
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </select>
        {hasFilters && (
          <button onClick={clearFilters}
            style={{ ...filterInputBase, background: "#fff5f5", color: "#dc2626", border: "1px solid #fecaca", cursor: "pointer", fontWeight: 600, fontSize: 13, whiteSpace: "nowrap", padding: "8px 14px" }}>
            Clear
          </button>
        )}
      </div>

      <div style={{ background: "#fff", borderRadius: 12, border: "1px solid #e2e8f0", overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 14 }}>
            <thead>
              <tr>
                {COLS.map((h) => (
                  <th key={h} style={{ padding: "11px 16px", textAlign: "left", fontSize: 12, fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.05em", background: "#f8fafc", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <TableSkeleton />
              ) : pagedItems.length === 0 ? (
                <tr>
                  <td colSpan={COLS.length}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "56px 20px", gap: 8 }}>
                      <p style={{ margin: 0, fontSize: 16, fontWeight: 600, color: "#374151" }}>No item masters found</p>
                      <p style={{ margin: 0, fontSize: 13, color: "#94a3b8" }}>
                        {hasFilters ? "Try adjusting your search or filters" : "No items have been created yet"}
                      </p>
                      {hasFilters ? (
                        <button onClick={clearFilters} style={{ marginTop: 8, padding: "8px 18px", background: "#3b82f6", color: "#fff", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer" }}>
                          Clear Filters
                        </button>
                      ) : (
                        <button onClick={() => setShowCreate(true)} style={{ marginTop: 8, padding: "8px 18px", background: "#3b82f6", color: "#fff", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}>
                          <PlusIcon /> Add First Item
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ) : (
                pagedItems.map((item, idx) => (
                  <tr key={item.id} className="bim-row"
                    style={{ borderBottom: "1px solid #f1f5f9", transition: "background 0.12s" }}
                    onClick={() => setViewId(item.id)}>
                    <td style={{ padding: "13px 16px", color: "#94a3b8", fontSize: 13 }}>
                      {(currentPage - 1) * PAGE_SIZE + idx + 1}
                    </td>
                    <td style={{ padding: "13px 16px", maxWidth: 180 }}>
                      <div style={{ fontWeight: 700, color: "#0f172a", fontSize: 13.5, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {item.item_name}
                      </div>
                    </td>
                    <td style={{ padding: "13px 16px", maxWidth: 180 }}>
                      <div style={{ fontSize: 13, color: "#475569", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {item.particulars || <span style={{ color: "#cbd5e1" }}>—</span>}
                      </div>
                    </td>
                    <td style={{ padding: "13px 16px" }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: "#334155" }}>
                        {parseFloat(item.default_qty).toLocaleString()}
                      </span>
                    </td>
                    <td style={{ padding: "13px 16px" }}>
                      <span style={{ fontSize: 12.5, color: "#64748b" }}>
                        {item.unit || <span style={{ color: "#cbd5e1" }}>—</span>}
                      </span>
                    </td>
                    <td style={{ padding: "13px 16px" }}>
                      <ActiveBadge value={item.is_active} />
                    </td>
                    <td style={{ padding: "13px 16px" }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: "#334155" }}>{item.created_by_name}</div>
                      <div style={{ fontSize: 11.5, color: "#94a3b8", marginTop: 1, display: "flex", alignItems: "center", gap: 3 }}>
                        <UserIcon /> {item.created_by_email}
                      </div>
                    </td>
                    <td style={{ padding: "13px 16px" }} onClick={(e) => e.stopPropagation()}>
                      <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                        <button title="View Details" className="bim-action-btn" onClick={() => setViewId(item.id)}
                          style={{ display: "flex", alignItems: "center", padding: "4px 6px", gap: 3, background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 6, cursor: "pointer", color: "#3b82f6", fontSize: 12, fontWeight: 600, transition: "opacity 0.15s" }}>
                          <EyeIcon />
                        </button>
                        <button title="Edit Item" className="bim-action-btn" onClick={() => setEditItem(item)}
                          style={{ display: "flex", alignItems: "center", padding: "4px 6px", gap: 3, background: "#fefce8", border: "1px solid #fde68a", borderRadius: 6, cursor: "pointer", color: "#d97706", fontSize: 12, fontWeight: 600, transition: "opacity 0.15s" }}>
                          <EditIcon />
                        </button>
                        <button title="Delete Item" className="bim-action-btn" onClick={() => setDeleteItem(item)}
                          style={{ display: "flex", alignItems: "center", padding: "4px 6px", gap: 3, background: "#fff5f5", border: "1px solid #fecaca", borderRadius: 6, cursor: "pointer", color: "#dc2626", fontSize: 12, fontWeight: 600, transition: "opacity 0.15s" }}>
                          <TrashIcon />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {!loading && totalCount > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            onPageChange={(p) => { if (p >= 1 && p <= totalPages) setCurrentPage(p); }}
          />
        )}
      </div>

      {showCreate && (
        <FormModal mode="create" initialData={null}
          onClose={() => setShowCreate(false)} onSuccess={handleCreateSuccess} />
      )}
      {editItem && (
        <FormModal mode="edit" initialData={editItem}
          onClose={() => setEditItem(null)} onSuccess={handleEditSuccess} />
      )}
      {viewId && (
        <ViewDetailModal itemId={viewId}
          onClose={() => setViewId(null)} onEdit={(item) => setEditItem(item)} />
      )}
      {deleteItem && (
        <DeleteConfirmModal item={deleteItem} onConfirm={handleDelete}
          onCancel={() => !deleting && setDeleteItem(null)} deleting={deleting} />
      )}
    </div>
  );
};

export default BuyerItemMaster;